
<template>
  <div :class="clasess" v-if="app.userInfo">
    <img v-if="isVip" src="https://chain-apply.oss-cn-shanghai.aliyuncs.com/pack/personal_crad_bg.png">
    <div :class="preflxCls+'-avater'">
      <z-panel
        v-if="app.userInfo.avatarFile"
        type="avater"
        width="60"
        height="60"
        :avaterUrl="app.ossUrl + app.userInfo.avatarFile.key"
      ></z-panel>
      <Avatar class="default-avater" v-else icon="ios-person" size="large" style="width: 60px;height:60px; border-radius: 50%"/>
    </div>
    <div :class="preflxCls+'-name'">
      <p class="name">{{app.userInfo.loginName}}</p>
      <p class="target">
          <img  v-if="isVip" src="https://chain-apply.oss-cn-shanghai.aliyuncs.com/pack/vip_icon1.png" alt="">
          {{app.userInfo.typeDisplay}}
        </p>
    </div>
    <div :class="preflxCls+'-button'">
      <Button type="primary" shape="circle" v-if="!isAttestation && !isVip" @click="authentication">立即认证</Button>
      <Button type="primary" shape="circle" v-if="(isAttestation || isVip) && !isSignined" @click="signinHandle">签到领蛋</Button>
      <Button type="primary" shape="circle"  disabled v-if="(isAttestation || isVip) && isSignined">今日已签到</Button>
    </div>
    <div :class="preflxCls+'-vipText'" v-if="isAttestation || isVip">
      <i class="iconfont icon-calendar"></i>&nbsp;
        已经签到
      <span class="day-num">{{app.userInfo.totalSignedDays}}</span>
        天&nbsp;&nbsp;明日签到
      <span class="day-num">+{{app.userInfo.tomorrowPoints}}</span>
    </div>
    <div :class="preflxCls+'-bottom'">
      <button class="left" @click="setInfoHandle">账号设置</button>
      <button class="right" @click="logoutHandle">退出</button>
    </div>
  </div>
</template>

<script>
const preflxCls = "z-userinfo";
import { oneOf } from "../../utils/assist.js";
import Emitter from '../../mixins/emitter.js' 
import ZPanel from '../panel/panel'
export default {
  name: "UserInfo",
  inject: ["app"],
  mixins: [Emitter],
  data() {
    return {
      preflxCls: preflxCls
    };
  },
  components: {ZPanel},
  computed: {
    clasess() {
      return [
        preflxCls,
        {
          [`${preflxCls}-vip-bg`]: this.app.userInfo.isVip === 1
        }
      ];
    },
    // 是否是认证设计师
    isAttestation() {
        if(this.app.userInfo && this.app.userInfo.type === 2 || this.app.userInfo.type === 3){
            return true;
        } 
        return false;
    },
    // 是否是Vip
    isVip() {
        if(this.app.userInfo && this.app.userInfo.isVip === 1) {
             return true;
        }
        return false;
    },
    // 是否已经签到
    isSignined() {
        if(this.app.userInfo && this.app.userInfo.hasSignined === 1) {
             return true;
        }
        return false;
    },
  },
  methods: {
    // 退出
    logoutHandle() {
      this.dispatch('ZNav', 'logout')
    },

    signinHandle() {
      this.dispatch('ZNav', 'signin')
    },

    // 立即认证
    authentication() {
      this.dispatch('ZNav', 'authenticationHandle')
    },

    // 账号设置
    setInfoHandle() {
      this.dispatch('ZNav', 'setInfo')
    }
    
  }
};
</script>



